// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { bannerStyles } from "@guestsupply/Overrides/Widgets/Basic/Banner";
import { color, ellipsis, mergeWithCss, xScreen } from "@guestsupply/XDL/Utilities";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

bannerStyles.wrapper = {
    css: css`
        width: 100%;
        display: flex;
        justify-content: center;
    `,
};
bannerStyles.overlayWrapper = {
    css: css`
        width: 100%;
        text-align: left;
        display: flex;
        ${xScreen("lte", "md")} {
            flex-direction: column;
            max-width: 100%;
        }
    `,
};
bannerStyles.heading = {
    as: "p",
    css: css`
        margin-bottom: 16px;
        ${TypographyStyle} {
            margin-bottom: 0px;
        }
    `,
};
bannerStyles.subHeading = {
    as: "p",
    css: css`
        display: block;
        margin-bottom: 20px;
        ${TypographyStyle} {
            margin-bottom: 0;
            ${xScreen("gt", "md")} {
                ${ellipsis(2)}
            }
        }
    `,
};
bannerStyles.slideCenteringWrapperStyles = {
    css: css`
        display: flex;
        flex-direction: column;
        ${xScreen("lte", "md")} {
            width: 100%;
            padding: 28px 16px;
        }
    `,
};
bannerStyles.contentImage = {
    css: css`
        width: 50%;
        height: 100%;
        max-height: 297px;
        border-radius: 0 4px 4px 0;
        position: relative;
        &:before {
            background: linear-gradient(90deg, ${color("common.ui1")} 0%, transparent 100%);
            width: 185px;
            height: 100%;
            content: "";
            position: absolute;
            left: 0;
            z-index: 2;
        }
        img {
            border: 1px solid ${color("common.ui1")};
            max-width: 100%;
            width: 100%;
            height: auto;
        }
        ${xScreen("lte", "md")} {
            width: 100%;
            height: 333px;
            max-height: 333px;
            border-radius: 4px 4px 0 0;
            order: -1;
            &:before {
                display: none;
            }
            img {
                border: 0;
            }
        }
        ${xScreen("lte", 767)} {
            height: 149px;
            max-height: 149px;
        }
    `,
};
